import { frontApiUrl } from '../../../../core/Api/Front/url';
import { Locale } from '../../../../core/i18n/Locale';
import { FeatureDiscoveryNotificationUndiscoveredResponseData } from '../../../../pages/api/front/feature-discovery-notifications/undiscovered';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';
import { FeatureDiscoveryNotificationFromTravelerAPI } from '../travelerapi/normalizer';

type GetUndiscoveredFeatureDiscoveryNotificationsFromFrontProps = {
    locale: Locale;
};

export async function getUndiscoveredFeatureDiscoveryNotificationsFromFront({
    locale,
}: GetUndiscoveredFeatureDiscoveryNotificationsFromFrontProps) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_feature_discovery_notifications_undiscovered', locale, {
                locale,
            }),
        ),
    );

    return handleResponse<FeatureDiscoveryNotificationUndiscoveredResponseData>(response);
}

type PostFeatureDiscoveryNotificationDiscoveredProps = {
    locale: Locale;
    featureDiscoveryNotification: FeatureDiscoveryNotificationFromTravelerAPI;
};

export async function postFeatureDiscoveryNotificationDiscoveredFromFront({
    locale,
    featureDiscoveryNotification,
}: PostFeatureDiscoveryNotificationDiscoveredProps) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_feature_discovery_notifications_discover', locale, {
                locale,
            }),
        ),
        {
            method: 'POST',
            body: JSON.stringify(featureDiscoveryNotification),
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );

    return handleResponse(response);
}
